'use client';
import React from 'react';
import { CookiesProvider } from 'react-cookie';

function CookieProvider({ children }: React.PropsWithChildren) {
  return <CookiesProvider defaultSetOptions={{ path: '/' }}>{children}</CookiesProvider>;
}

export default CookieProvider;
